export default {
  title: 'Bestellmethoden',
  paywall: {
    live_title: '{{name}} ist live!',
  },
  tabs: {
    general: 'General',
    pickup: 'Abholung',
    delivery: 'Lieferung',
    table_ordering: 'Tischbestellung',
  },
  modals: {
    update_confirmation: {
      title: 'Bist du sicher, dass du die neuen Änderungen speichern willst?',
      buttons: {
        confirm: 'Bestätigen',
        cancel: 'Abbrechen',
      },
    },
    switch_live_orders: {
      titles: {
        disable: 'Bist du sicher, dass du Live-Bestellungen deaktivieren willst?',
        enable: 'Bist du sicher, dass du Live-Bestellungen einschalten willst?',
      },
      buttons: {
        yes: 'Ja',
        no: 'Nein',
      },
    },
  },
  toasts: {
    failed_to_save_changes: 'Änderungen konnten nicht gespeichert werden',
    changes_got_saved: 'Änderungen wurden gespeichert',
    table_ordering_saved: 'Tischbestellung gespeichert',
  },
};
